(ns practitest.frontend.components2.buttons
  (:require [practitest.frontend.common.mixpanel :as mixpanel]
            [practitest.frontend.pt-ts-bridge :refer [Button]]
            [clojure.string :as str]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.utils :refer [development-only example
                                                      register-components!]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.tooltip :as tooltip]
            [practitest.frontend.components2.spinners :as spinners]
            [reagent.core :as reagent]))

(defn- process-css-class
  [css]
  (if (coll? css)
    (str/join " " css)
    (str css)))

(defn
  ^{:component? true}
  button
  "Main button class for practitest-styled buttons. Does not support custom children elements,
   only `text` and `icon` is supported now."
  [{:keys [primary?
           tertiary?
           quaternary?
           danger?
           disabled?
           active?
           title
           tooltip
           class
           id
           text
           icon
           href
           download
           test-id
           size
           end-icon
           loading? ;; spinner after the text, blocks clicks
           on-click
           shape]
    :as   props}]
  (let [btn [:r> Button
             #js {:href href
                  :id id
                  :type (cond
                          danger? "danger"
                          primary? "primary"
                          tertiary? "tertiary"
                          quaternary? "quaternary"
                          :else "secondary")
                  :active active?
                  :size size
                  :title title
                  :shape shape
                  :className (process-css-class class)
                  :text (reagent/as-element text)
                  :icon (reagent/as-element icon)
                  :endIcon (reagent/as-element end-icon)
                  :download download
                  :data-testid test-id
                  :disabled (boolean disabled?)
                  :loading (boolean loading?)
                  :loadingIcon (when loading?
                                 (reagent/as-element
                                   [spinners/mux-spinner
                                    {:size  :text
                                     :color (if (or primary? danger?)
                                              :inverted
                                              :primary)}]))
                  :onClick on-click}]]
    (if tooltip
      [tooltip/mux-tooltip
       {}
       tooltip
       (fn [tooltip-props]
         [:span tooltip-props btn])]
      btn)))

(defn 
  ^{:component? true}
  icon-button
  "Special button that looks like plain icon but has hoverable state, tooltip and acts as button"
  [{:keys [class tooltip disabled? icon on-click mixpanel test-id]}]
  [tooltip/mux-tooltip
   {}
   tooltip
   (fn [props]
     [:span
      (merge (dom/add-test-id {:role "button"} test-id)
             (if tooltip
               props
               {})
             {:class (dom/append-class
                       (dom/classes-pairs-v :m-icon-button true
                                            :disabled disabled?)
                       class)
              :on-click (fn [e]
                          (when (and (not disabled?)
                                     on-click)
                            (when mixpanel
                              (apply mixpanel/track mixpanel))
                            (on-click e)))})
      icon])])

(development-only
  (defn ^{:component-example button} icon-button-examples []
    [:div
     (example
       [icon-button {:icon [icons/mux-trash]
                     :tooltip "Remove"}])
     (example
       [icon-button {:icon [icons/mux-paperclip]
                     :disabled? true
                     :tooltip "This icon is disabled"}])])

  (defn ^{:component-example button} button-examples []
    [:div
     (example
       [button {:text "Button with text"}])
     (example
       [button {:primary? true
                :text     "Primary Button with text"}])
     (example
       [button {:text     "Button with an icon"
                :icon     [icons/mux-calendar-manual]}])
     (example
       [button {:text     "Tertiary Button"
                :tertiary? true
                :end-icon [icons/mux-calendar-manual]
                :icon     [icons/mux-calendar-manual]}])
     (example
       [button {:text     "Tertiary Button Disabled"
                :tertiary? true
                :disabled? true
                :end-icon [icons/mux-calendar-manual]
                :icon     [icons/mux-calendar-manual]}])
     (example
       [button {:primary? true
                :loading? true
                :text     "Primary Button loading"}])
     (example
       [button {:tertiary? true
                :loading? true
                :text     "Tertiary Button loading"}])])

  (defn ^{:component-example button} button-examples2 []
    (reagent/with-let [state (reagent/atom {})]
      [:div
       [:div {:style {:display        "flex"
                      :flex-direction "row"
                      :gap            "1rem"}}
        [:label.clickable
         [:input
          {:type      "checkbox"
           :checked   (:disabled? @state)
           :on-change (fn [e]
                        (swap! state assoc :disabled? (dom/event-value e)))}]
         " :disabled? "]

        [:label.clickable
         [:input
          {:type      "checkbox"
           :checked   (:primary? @state)
           :on-change (fn [e]
                        (swap! state assoc :primary? (dom/event-value e)))}]
         " :primary? "]]

       [:p]

       [button {:disabled? (:disabled? @state)
                :primary?  (:primary? @state)
                :text      "Controlled button"}]])))

(register-components!)
